import React from 'react';
import { Box, Paper } from '@material-ui/core';
import { EnabledStart, Start, Status, Stop } from './components';

const NPS_TOOLBAR_ENABLED = JSON.parse(localStorage.getItem('_nps_toolbar_enabled') || '0');

const NPSToolbar = () => {
  if (!NPS_TOOLBAR_ENABLED) return null;

  return (
    <Box
      component={Paper}
      sx={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        p: 1,
      }}
    >
      <Start />

      <Box sx={{ ml: 1 }}>
        <Stop />
      </Box>

      <Box sx={{ ml: 1 }}>
        <EnabledStart />
      </Box>

      <Box sx={{ ml: 1 }}>
        <Status />
      </Box>
    </Box>
  );
};

export default NPSToolbar;
